export default __webpack_public_path__ + "static/media/Deacon's Helm of the Sacred Mountain.4bb85774.jpg";